import * as React from 'react';
const { connect } = require('react-redux');
import { IMagazinePageSection } from 'models/common/section';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import renderIcon from 'helpers/renderIcon';
import { browserHistory } from 'react-router';
import { IStore } from 'redux/IStore';

interface IProps {
	section: IMagazinePageSection;
	siteCode: string;
	t?: (key: string) => string;
	activeTagHandleClick?: (activeTag: object) => void;
}

interface IState {
	index: number;
	activeTag: object;
	categoriesNotScrolled: boolean;
	categoriesScrolledToTheEnd: boolean;
}

let scrollTimeout;

@connect(
	(state: IStore) => ({
		pathname: state.routing.locationBeforeTransitions.pathname,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType14 extends React.Component<IProps, IState> {
	private tagsContainerRef;

	constructor(props) {
		super(props);

		this.tagsContainerRef = React.createRef();

		this.state = {
			index: null,
			activeTag: {},
			categoriesNotScrolled: true,
			categoriesScrolledToTheEnd: false,
		};
	}

	public componentDidMount() {
		this.tagsContainerRef.current.addEventListener('scroll', () => {
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				this.handleCategoriesScroll();
			}, 50);
		});
		this.handleCategoriesScroll();
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.siteCode !== this.props.siteCode) {
			// Reset the index and active tag when switching magazine pages
			this.setState({
				index: null,
				activeTag: {},
			});
			this.props.activeTagHandleClick(null);
		}
	}

	public componentWillUnmount() {
		this.tagsContainerRef.current.removeEventListener('scroll', () => {
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				this.handleCategoriesScroll();
			}, 50);
		});
	}

	private handleCategoriesScroll() {
		const tagsContainer = this.tagsContainerRef.current;
		if (tagsContainer) {
			this.setState({
				categoriesNotScrolled: tagsContainer.scrollLeft === 0,
				categoriesScrolledToTheEnd:
					Math.abs(tagsContainer.scrollLeft) >= tagsContainer.scrollWidth - tagsContainer.clientWidth,
			});
		}
	}

	public handleClick(clickedTag, index) {
		if (index !== this.state.index) {
			this.setState({
				index: index,
				activeTag: clickedTag,
			});
			this.props.activeTagHandleClick(clickedTag);
			browserHistory.push(`/magazine/page/${this.props.siteCode}/tag/${clickedTag.value}`);
		} else {
			this.setState({
				index: null,
				activeTag: {},
			});
			this.props.activeTagHandleClick(null);
			browserHistory.push(`/magazine/page/${this.props.siteCode}`);
		}
	}

	private scrollCategories(direction: 'left' | 'right') {
		const tagsContainer = this.tagsContainerRef.current;
		if (tagsContainer && direction) {
			const pxToScrollOnClick = 240;

			if (direction === 'right') {
				tagsContainer.scroll({
					left: pxToScrollOnClick + tagsContainer.scrollLeft,
					behavior: 'smooth',
				});
			}
			if (direction === 'left') {
				tagsContainer.scroll({
					left: tagsContainer.scrollLeft - pxToScrollOnClick,
					behavior: 'smooth',
				});
			}
		}
	}

	public render() {
		const { elements } = this.props.section.data;
		const articleTags: any = elements[0];

		const renderElements = () => {
			return articleTags.articleTags.map((tag, index) => {
				return (
					<div
						key={`${tag}${index}`}
						className={`sectionType14-tagsContainer-tag ${this.state.index === index ? 'active' : ''}`}
						onClick={() => this.handleClick(tag, index)}
					>
						<p>{tag.value}</p>
					</div>
				);
			});
		};

		return (
			<div className="container sectionType14-container">
				<div className="row">
					<div className="col-lg-12">
						<div className="filters">
							{!this.state.categoriesNotScrolled && (
								<div className="scroll-button scroll-left-button" onClick={() => this.scrollCategories('left')}>
									{renderIcon('move_up')}
								</div>
							)}
							<div
								className={`sectionType14-tagsContainer ${
									this.state.categoriesScrolledToTheEnd && this.state.categoriesNotScrolled ? 'noScroll' : ''
								}`}
								ref={this.tagsContainerRef}
							>
								{renderElements()}
							</div>
							{!this.state.categoriesScrolledToTheEnd && (
								<div className="scroll-button scroll-right-button" onClick={() => this.scrollCategories('right')}>
									{renderIcon('move_up')}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType14 };
